import * as angular from 'angular';

import template from './embed-modal.html';

const embedModalDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      report: '=',
      reportRun: '<',
      owner: '<',
    },
    link: function ($scope: angular.IScope, elem, attrs) {
      elem.on('click.embedModal', (event) => {
        if (!$scope.reportRun || !$scope.owner) {
          // safety check for opening modal before models have loaded
          return;
        }
        const modal = Modal.open(
          {
            report: $scope.report,
            reportRun: $scope.reportRun,
            owner: $scope.owner,
          },
          {
            controller: function () {},
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.embedModal'));
    },
  };
};

embedModalDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('embedModal', embedModalDirective);
